<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <div class="row">
                                                <!-- card1 start -->
                                                <div class="col-md-6 col-xl-3">
                                                    <div class="card widget-card-1">
                                                        <div class="card-block-small">
                                                            <i class="icofont icofont-pie-chart bg-c-blue card1-icon"></i>
                                                            <span class="text-c-blue f-w-600">Total Openings</span>
                                                            <h4 v-html="openings_count"></h4>
                                                            <div>
                                                                <span class="f-left m-t-10 text-muted">
                                                                    <i class="text-c-blue f-16 icofont icofont-eye m-r-10"></i>
                                                                    <a href="/openings">View Openings</a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- card1 end -->
                                                <!-- card1 start -->
                                                <div class="col-md-6 col-xl-3">
                                                    <div class="card widget-card-1">
                                                        <div class="card-block-small">
                                                            <i class="icofont icofont-ui-clock bg-c-pink card1-icon"></i>
                                                            <span class="text-c-pink f-w-600">Recent Applications</span>
                                                            <h4 class="recent_applications" v-html="recent_applications_count"></h4>
                                                            <div>
                                                                <span class="f-left m-t-10 text-muted">
                                                                    <i class="text-c-pink f-16 icofont icofont-sand-clock m-r-10"></i>Past
                                                                    <select v-model="recent_in_days" class="duration_select"
                                                                        v-on:change="getApplicantsByDuration">
                                                                        <option selected="selected" value="7">1 week</option>
                                                                        <option value="14">2 weeks</option>
                                                                        <option value="31">1 month</option>
                                                                        <option value="62">2 months</option>
                                                                        <option value="93">Quarter</option>
                                                                        <option value="126">Half</option>
                                                                        <option value="366">1 Year</option>
                                                                    </select>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- card1 end -->
                                                <!-- card1 start -->
                                                <div class="col-md-6 col-xl-3">
                                                    <div class="card widget-card-1">
                                                        <div class="card-block-small">
                                                            <i class="icofont icofont-listine-dots bg-c-green card1-icon"></i>
                                                            <span class="text-c-green f-w-600">Total Applications</span>
                                                            <h4 v-html="applicant_count"></h4>
                                                            <div>
                                                                <span class="f-left m-t-10 text-muted">
                                                                    <i class="text-c-green f-16 icofont icofont-calendar m-r-10"></i>All
                                                                    Time
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- card1 end -->
                                                <!-- card1 start -->
                                                <div class="col-md-6 col-xl-3">
                                                    <div class="card widget-card-1">
                                                        <div class="card-block-small">
                                                            <i class="icofont icofont-arrow-down bg-c-yellow card1-icon"></i>
                                                            <span class="text-c-yellow f-w-600">Recruited</span>
                                                            <h4>{{recruited_count}}</h4>
                                                            <div>
                                                                <span class="f-left m-t-10 text-muted">
                                                                    <i class="text-c-yellow f-16 ti-layout m-r-10"></i>Via
                                                                    Portal
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- card1 end -->

                                                <div class="col-md-12 col-xl-8" v-if="$checkPerm('report.view')">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h5>Recently Viewed</h5>
                                                            <div class="card-header-left"></div>
                                                            <div class="card-header-right"></div>
                                                        </div>
                                                        <div class="card-block" style="max-height: 400px; overflow-y: auto;">
                                                            <div v-if="recently_viewed.length > 0">
                                                                <div class="search-content" v-for="result in recently_viewed"
                                                                    v-if="result.joblisting !== undefined">
                                                                    <div>
                                                                        <div class="card-block">
                                                                            <h5 class="card-title">
                                                                                <a v-bind:href="'/opening/' + result.joblisting[0].id + '/application/' + result.id"
                                                                                    target="_blank">
                                                                                    {{result.firstname + " " +
                                                                                    result.lastname}}
                                                                                </a>
                                                                            </h5>
                                                                            <p class="card-text text-muted">
                                                                                <b>Applied for: </b> <a v-bind:href="'/opening/' + result.joblisting[0].id">{{result.joblisting[0].name}}</a>
                                                                            </p>
                                                                            <p class="card-text text-muted">
                                                                                <b>Email Address:</b>
                                                                                {{result.emailaddress}}
                                                                            </p>
                                                                            <p class="card-text"><small class="text-muted">Last
                                                                                    updated at {{result.updated_at}}</small></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-6 col-xl-4" v-if="$checkPerm('report.view')">
                                                    <div class="card review-task">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Most Applied Openings</h5>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">
                                                            <div class="table-responsive">
                                                                <table class="table table-hover">
                                                                    <tbody>
                                                                        <tr v-for="opening in top_openings">
                                                                            <td>
                                                                                <a v-bind:href="'/opening/'+opening.joblisting_id">
                                                                                    <h6>{{opening.name}}</h6>
                                                                                    <p class="text-muted">{{opening.requiredskill}}</p>
                                                                                </a>

                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .task-sale-card {
        max-height: 400px;
        overflow-y: auto;
    }

    .line-height-2-5 {
        line-height: 2.5 !important;
    }

    .card-controls li {
        display: inline;
    }

    .green {
        color: #05ec05 !important;
    }

    .red {
        color: #ff0000 !important;
    }

    .duration_select {
        border: 0px;
        border-bottom: 0.7px solid #FC6180;
        margin-left: 2px;
        color: #919aa3;
        cursor: pointer;
    }

    .recent_applications a {
        font-size: 28px !important;
    }
</style>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import Vue from 'vue'

    export default {
        name: 'Dashboard',
        data() {
            return {
                openings_count: '<span class="pcoded-micon"><i class="ti-reload rotate-refresh"></i></span>',
                applicant_count: '<span class="pcoded-micon"><i class="ti-reload rotate-refresh"></i></span>',
                recent_applications_count: '<span class="pcoded-micon"><i class="ti-reload rotate-refresh"></i></span>',
                recruited_count: 0,
                recent_in_days: 7,
                top_openings: [],
                recently_viewed: []
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {
            this.stats()
        },
        methods: {
            getApplicants: function () {
                var applicants = {
                    what: 'ListApplicants',
                    params: {
                        deleted: 'true'
                    }
                }

                this.$socket.makeGetRequest(applicants)
                    .then((response) => {
                        if (response.type == 'ListApplicants') {
                            this.applicant_count = response.data.length
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        this.applicant_count = "-"
                    })
            },

            getAllOpenings: function () {

                var get_openings_request = {
                    what: 'openings'
                }

                this.$socket.makeGetRequest(get_openings_request)
                    .then((response) => {
                        if (response.type == 'openings') {
                            this.openings_count = response.data.length
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        this.openings_count = "-"
                    })
            },

            getApplicantsByDuration: function () {

                this.recent_applications_count = '<span class="pcoded-micon"><i class="ti-reload rotate-refresh"></i></span>'

                var recent = {
                    what: 'RecentApplications',
                    params: {
                        days: this.recent_in_days
                    }
                }

                this.$socket.makeGetRequest(recent)
                    .then((response) => {
                        if (response.type == 'RecentApplications') {
                            this.recent_applications_count = '<a style="font-size: 28px !important;color:var(--primary)" href="/recentapplications/' + this.recent_in_days + '">' + response.data.length + '</a>'
                            console.log(response.data)
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        this.recent_applications_count = "-"
                    })
            },

            getTopOpenings: function () {
                var request = {
                    what: 'GetTopOpenings',
                    params: {
                        company_id: this.$store.getters.user_data.data.company_id
                    }
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == 'GetTopOpenings') {
                            this.top_openings = response.data
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            getRecentlyViewed: function () {
                var request = {
                    what: 'RecentlyViewed'
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == 'RecentlyViewed') {
                            this.recently_viewed = response.data
                            console.log(response)
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            stats: function () {
                this.getAllOpenings()
                this.getApplicants()
                this.getApplicantsByDuration()
                this.getTopOpenings()
                this.getRecentlyViewed()
            }
        },
        computed: {

        }
    }
</script>